
import { borderRadius, display, fontSize, height, padding } from '@mui/system';
import React, { useState } from 'react';
import numWords from 'num-words';


const Receipt1 = ({
  isDebitSelected,
  selectedPavtiNos,
  pavtiDataArray,
  sansthaName,
  schoolName,
  taluka,
  jilha,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "English"
  );


  if (!isDebitSelected || !selectedPavtiNos || selectedPavtiNos.length === 0) {
    return <p> {language === "English" ? "Select Invoice Numbers  " : "पावती क्रमांक निवडा "} </p>;
  }

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const printReceipt = () => {
    const printWindow = window.open('', '_blank');
    const receiptContent = pavtiDataArray.map((pavtiData, index) => `
      <div class="receipt" style="border: 1px solid #000; padding: 10px; margin: 20px 0; width: 800px; background-color: white; page-break-inside: avoid; padding-top:0px">
      <div id="voucher" style="background-color: #E8E8E8; border-radius: 5px;">
  <div class="header" style="text-align: center;">
    <h3 class="centerText">${sansthaName}</h3>
    <h4 class="centerText">${schoolName}</h4>
    <p class="centerText">Taluka: ${taluka}, Dist: ${jilha}</p>
  </div>
</div>

        <table class="table" style="width: 100%; border-collapse: collapse;">
          <tbody>
            <tr>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;"><strong>Pavti No:</strong></td>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;">${pavtiData.pavtiNo}</td>
            </tr>
            <tr>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;"><strong>Date:</strong></td>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;">${new Date(pavtiData.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
            </tr>
            <tr>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;"><strong>Aaj Mitis Shree:</strong></td>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;">${pavtiData.khatePrakar}</td>
            </tr>
            <tr>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;"><strong>Yanchyakdun Rakkam:</strong></td>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;">Rs. ${pavtiData.Amount} (IN WORDS - Rs. ${numWords(pavtiData.Amount).toUpperCase()} ONLY)</td>
            </tr>
             ${pavtiData.Remark ? `
<tr>
  <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;">
    <strong>Remark:</strong>
  </td>
  <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;">
    ${pavtiData.Remark}
  </td>
</tr>
` : ''}
            <tr>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;"><strong>Amount:</strong></td>
              <td class="tableCell" style="border: 1px solid #ddd; padding: 8px;">Rs. ${parseFloat(pavtiData.Amount).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
        <div class="signatureSection" style="display: flex; justify-content: space-between; margin-top: 10px;">
          <div class="signatureBox" style="width: 30%; border: 1px solid gray; padding: 0px; text-align: center;">
            <p style="margin-bottom:0px;">Signature</p>
          </div>
          <div class="signatureBox" style="width: 30%; border: 1px solid gray; padding: 0px; text-align: center;">
            <p  style="margin-bottom:0px;">Accountant</p>
          </div>
        </div>
      </div>
    `).join('');
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Receipt</title>
          <style>
          @page{
          size: A4 Potrait;
          margin:1mm;
          }
            .receipt {
              border: 1px solid blue;
              padding: 5px;
              margin: 20px 0;
              width: 800px;
              background-color: white;
            }
            .header {
              text-align: center;
              margin: 0px;
              padding: 2px; 
            }
            .centerText {
              text-align: center;
            }
            .table {
              width: 100%;
              border-collapse: collapse;
            }
            .tableCell {
              border: 1px solid #ddd;
              padding: 8px;
            }
            .signatureSection {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
            }
            .signatureBox {
              width: 40%;
              border: 1px solid #000;
              padding: 0px;
              text-align: center;
            }
            .printButton {
              background-color: #87CEFA;
              color: white;
              padding: 10px 20px;
              font-size: 16px;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              transition: background-color 0.3s ease;
              margin-top: 20px;
            }
            .modalOverlay {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: white;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .modalContent {
              background-color: white;
              padding: 10px;
              border-radius: 5px;
              max-width: 100%;
              max-height: 100%;
              background-color: white;
            }
            .closeButton {
              background-color: red;
              color: white;
              border: none;
              padding: 10px;
              border-radius: 50%;
              cursor: pointer;
              float: right;
              font-size: 16px;
            }
              
            .viewButton {
              background-color: #87CEFA;
              color: white;
              padding: 10px 20px;
              font-size: 16px;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              transition: background-color 0.3s ease;
              margin-bottom: 20px;
            }
            .receipt {
              page-break-inside: avoid;
            }
          </style>
        </head>
        <body>
          ${receiptContent}
          <script>
            window.print();
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };
  
  const convertAmountToWords = (amount) => {
    if (amount == null || isNaN(amount)) return 'ZERO';
  
    const [integerPart, decimalPart] = amount.toString().split('.');
  
    const integerWords = numWords(parseInt(integerPart, 10)).toUpperCase();
    const decimalWords = decimalPart ? ` AND ${numWords(parseInt(decimalPart, 10)).toUpperCase()} PAISA` : '';
  
    return `${integerWords}${decimalWords}`;
  };
  

  return (
    <div>
      {/* View Receipt Button */}
      <button
        onClick={openModal}
        style={styles.viewButton}
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#87CEFA')}
        onMouseLeave={(e) => (e.target.style.backgroundColor = 'rgb(54 134 183)')}
      >
        View Receipt
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div style={{...styles.modalOverlay, overflow:'scroll'}} >
          <div style={{...styles.modalContent}}>
          <div style={{display:'flex', float:'right', marginTop:'-17px', gap:'10px'}}>
             <button
              onClick={printReceipt}
              style={styles.printButton}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#4f93dd')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#137ef2')}
            >
              Print
            </button>
            <button style={styles.closeButton} onClick={closeModal}>
              X
            </button>
          </div>
            {/* Receipt Content */}
            {pavtiDataArray.map((pavtiData, index) => (
              
              <div className="receipt" key={index} style={styles.receiptContainer}>
              <div style={{ backgroundColor: '		#E8E8E8', borderRadius: '5px' }}>
  <div style={styles.header}>
    <h6 style={styles.centerText}>{sansthaName}</h6>
    <h5 style={styles.centerText}>{schoolName}</h5>
    <p style={styles.centerText}>
      {language === "English" ? "Taluka: " : "तालुका: "} {taluka}, 
      {language === "English" ? " District: " : " जिल्हा: "} {jilha}
    </p>
  </div>
</div>


                <table style={styles.table}>
                <tbody>
                    <tr>
                      <td style={styles.tableCell}><strong> {language === "English" ? "Voucher No. " : "व्हा. नं. "} </strong></td>
                      <td style={styles.tableCell}>{pavtiData.pavtiNo}</td>
                    </tr>
                    <tr>
                      <td style={styles.tableCell}><strong>{language === "English" ? "Date " : "दिनांक "}</strong></td>
                      <td style={styles.tableCell}>{new Date(pavtiData.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                    </tr>
                    <tr>
                      <td style={styles.tableCell}><strong>{language === "English" ? "Account Type " : "खाते प्रकार "}</strong></td>
                      <td style={styles.tableCell}>{pavtiData.khatePrakar}</td>
                    </tr>
                    <tr>
                      <td style={styles.tableCell}><strong>{language === "English" ? "Amount in Words: " : "रक्कम अक्षरी "}</strong></td>
                      <td style={styles.tableCell}>
  Rs. {convertAmountToWords(pavtiData.Amount)} ONLY
              </td>
                      {/* <td style={styles.tableCell}>Rs. {pavtiData.Amount} (IN WORDS - Rs. {(numWords(pavtiData.Amount).toUpperCase())} ONLY)</td> */}
                    </tr>
                    <tr>
                      <td style={styles.tableCell}><strong>{language === "English" ? "Amount  " : "रक्कम  "}</strong></td>
                      <td style={styles.tableCell}>Rs. {parseFloat(pavtiData.Amount).toFixed(2)}</td>
                    </tr>
                    {pavtiData.Remark && (
  <tr>
    <td style={styles.tableCell}>
      <strong>{language === "English" ? "Remark" : "टिप्पणी"}</strong>
    </td>
    <td style={styles.tableCell}>{pavtiData.Remark}</td>
  </tr>
)}

                  </tbody>

                </table>

                <div style={styles.signatureSection}>
                  <div style={styles.signatureBox}>
                    <p  style={{paddingBottom:'0px', bottom:'0', marginTop:'20px', marginBottom:'0'}}> <b>{language === "English" ? "Sign " : "सही "}</b></p>
                  </div>
                  <div style={styles.signatureBox}>
                    <p  style={{paddingBottom:'0px', bottom:'0', marginTop:'20px', marginBottom:'0'}}><b>{language === "English" ? "Accountant " : "लेखापाल "}</b></p>
                  </div>
                </div>
              </div>
            ))}

           
          </div>
        </div>
      )}
    </div>
  );
};

// Styles for the component
const styles = {
  receiptContainer: {
    border: '1px solid black',
    padding: '10px',
    margin: '20px 0',
    width: '860px',
    backgroundColor: 'white',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
    borderRadius:'5px'
  },
  header: {
    textAlign: 'center',
    margin: '0px',
    padding:'10px'
  },
  centerText: {
    textAlign: 'center',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },

  tableCell: {
    border: '1px solid #ddd',
    padding: '7px',
    fontSize:'15px'
  },

  signatureSection: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
    textAlign: 'center',
  },

  signatureBox: {
    width: '30%',
    border: '1px solid #000',
    textAlign: 'center',
  },
  printButton: {
    backgroundColor: '#137ef2',
    color: 'white',
    padding: '3px 7px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'background-color 0.3s ease',
  },

  modalOverlay: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0', 
    backgroundColor: '#fff',
    display: 'flex',  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    height:'100vh',
    paddingBottom:'100px',
  },
  
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    maxWidth: '100%',
    maxHeight: '100%',
    backgroundColor: 'white',
  },

  closeButton: {
    backgroundColor: 'red',
    color: 'white',
    border: 'none',
    padding: '2px',
    borderRadius: '50%',
    cursor: 'pointer',
    float: 'right',
    right:'0',
    fontSize: '17px',
    width:'28px',
    height:'28px',
  },

  viewButton: {
    backgroundColor: 'rgb(54 134 183)',
    color: 'white',
    padding: '5px 12px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'background-color 0.3s ease',
    marginBottom: '20px',
  },
};

export default Receipt1;